export const TEAM_IMAGE_FALLBACK = "/teams/Abomination Racing.png";

export function getTeamImage(teamName) {
  const name = String(teamName || "").trim();
  return name ? `/teams/${name}.png` : TEAM_IMAGE_FALLBACK;
}

export function useTeamImageFallback(event) {
  const image = event.currentTarget;
  if (image.dataset.teamFallbackApplied) return;
  image.dataset.teamFallbackApplied = "true";
  image.src = TEAM_IMAGE_FALLBACK;
}
